import { Button, Container, Row, Spinner } from "react-bootstrap";
import { useReactTable, getCoreRowModel, flexRender, createColumnHelper } from "@tanstack/react-table";
import React, { useEffect, useState, useMemo } from "react";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong, faPlus } from "@fortawesome/free-solid-svg-icons";
import MusicFilesManager from "./MusicFilesManager";
import AddPlaylist from "./modals/addPlaylist";
import ImsPlaylistsService from "../services/imsPlaylistsService";
import PlaylistView from "./common/PlaylistView";
import Col from "react-bootstrap/Col";
import FileView from "./common/FileView";
import MusicFilesService from "../services/musicFilesService";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import dictionary from "../PL.json";
import ConfirmationModalContextProvider from "./common/modalConfirmationContext";

const columnHelper = createColumnHelper();

function ImsInfo() {
  const [listOfPlaylists, setListOfPlaylists] = useState([]);
  const [filesCount, setFilesCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const columns = useMemo(() => [
    columnHelper.accessor("lp", {
      header: "lp",
      cell: (cell) => cell.row.index + 1,
    }),
    columnHelper.accessor("name", {
      header: dictionary.IMSinfo.table.header.name,
      cell: (cell) => cell.getValue(),
    }),
    columnHelper.accessor("start", {
      header: dictionary.IMSinfo.table.header.start,
      cell: (cell) => cell.getValue(),
    }),
    columnHelper.accessor("end", {
      header: dictionary.IMSinfo.table.header.end,
      cell: (cell) => cell.getValue(),
    }),
    columnHelper.accessor("filesCount", {
      header: dictionary.IMSinfo.table.header.filesCount,
      cell: (cell) => cell.getValue(),
    }),
  ]);

  const table = useReactTable({
    data: listOfPlaylists,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  const getInfo = async () => {
    const { data: playlists } = await ImsPlaylistsService.getAll();
    let temp = [...playlists.list];
    temp.sort((a, b) => {
      //by date, defined in a.start
      const dateA = new Date(a.start).getTime();
      const dateB = new Date(b.start).getTime();
      return dateA - dateB;
    });
    setListOfPlaylists([...temp]);
    // console.log(listOfPlaylists);
  };

  const getFiles = async () => {
    const { data: files } = await ImsPlaylistsService.getAllFiles();
    if (files !== null && files !== undefined && files.length) setFilesCount(files.length);
    setLoading(false);
  };

  useEffect(() => {
    try {
      getInfo();
      getFiles();
    } catch (e) {
      toast.error("Nie można pobrać danych o playlistach");
    }
  }, []);

  // const handleCloseFileManager = () => {
  //     setShowFileManager(false);
  // }

  // const returnToListOfPlaylist = async () => {
  //     setPlaylistToView(null);
  //     await uploadPlaylists();
  //     await uploadFiles();
  // }

  return (
    <React.Fragment>
      <Breadcrumb style={{ backgroundColor: "#DDDDDD" }}>
        <Breadcrumb.Item
          style={{ marginTop: 3, marginLeft: 3, marginBottom: 3, marginRight: 0 }}
          href="/"
        >
          Home
        </Breadcrumb.Item>
        <Breadcrumb.Item style={{ marginTop: 3, marginLeft: 3, marginBottom: 3, marginRight: 0 }}>
          Zarządzanie muzyką
        </Breadcrumb.Item>
        <Breadcrumb.Item
          style={{ marginTop: 3, marginLeft: 3, marginBottom: 3, marginRight: 0 }}
          active
        >
          IMS info
        </Breadcrumb.Item>
      </Breadcrumb>
      <div className="App">
        <div>
          <ToastContainer />
        </div>
        {loading && (
          <Container className="text-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Container>
        )}
        {!loading && <Container>
          <p>{dictionary.IMSinfo.filesCount }<span className="badge bg-secondary ms-2">{!loading && filesCount}</span></p>
          <hr />
          {(listOfPlaylists === null || listOfPlaylists === undefined || listOfPlaylists.length === 0) && (
            <p> {dictionary.IMSinfo.noPlaylists}</p>
          )}
          {listOfPlaylists.length > 0 && (
            <>
              <p>{dictionary.IMSinfo.title}</p>
              <table className="table table-striped table-bordered align-middle text-center">
                <thead>
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                      {headerGroup.headers.map((header) => (
                        <th
                          key={header.id}
                          colSpan={header.colSpan}
                          className="text-center align-middle"
                        >
                          {flexRender(header.column.columnDef.header, header.getContext())}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody>
                  {table.getRowModel().rows.map((row) => (
                    <tr key={row.id}>
                      {row.getVisibleCells().map((cell) => (
                        <td
                          key={cell.id}
                          className="text-center"
                        >
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </Container>}
      </div>
    </React.Fragment>
  );
}

export default ImsInfo;
